import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveTagRequestFailure() {
      return getState().isFailure;
    },
    isRemoveTagRequestPending() {
      return getState().isPending;
    },
    isRemoveTagRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
